export default __webpack_public_path__ + "static/timelesswallet-8f84280d6f18810bfdfe017b2b2674b9.jpeg";